<template>
  <div>
    <h3>Nouvelle conversation</h3>
    <mdb-card v-if="step == 0" class="form-card">
      <mdb-card-body>
        <mdb-card-title> Créer une conversation</mdb-card-title>
        <mdb-card-text>Avec qui souhaitez vous dialoguer?</mdb-card-text>
        <ListUsers
          id="addConvSelectedList"
          :users="selected"
          removable="true"
          @remove-user="removeContact"
        ></ListUsers>
        <mdb-input v-model="searchQuery" label="Rechercher"></mdb-input>
        <ListUsers
          id="addConvContactList"
          :users="results"
          acceptable="true"
          @accept-user="selectContact"
        ></ListUsers>
        <mdb-btn class="orange darken-1" rounded @click="doneSelectingUsers">Suivant</mdb-btn>
      </mdb-card-body>
    </mdb-card>

    <mdb-card v-if="step == 1" class="form-card">
      <mdb-card-body>
        <a class="back" @click="() => step = step - 1">
          <mdb-icon icon="chevron-left" />
        </a>
        <mdb-card-title>Créer une conversation</mdb-card-title>
        <mdb-card-text
          v-if="this.selected.length > 0"
        >A propos de quoi voulez-vous parler? Vous devrez tous les {{this.selected.length + 1}} répondre à la question...</mdb-card-text>
        <mdb-card-text v-else>Sur quel sujet souhaitez-vous écrire?</mdb-card-text>
        <mdb-input type="textarea" label="Votre question" :rows="3" v-model="question"></mdb-input>
        <mdb-alert color="danger" v-show="!valid2">Quel est la question / le sujet ?</mdb-alert>
        <mdb-btn class="orange darken-1" rounded @click="doneWritingQuestion">Suivant</mdb-btn>
      </mdb-card-body>
    </mdb-card>

    <mdb-card v-if="step == 2" class="form-card">
      <mdb-card-body>
        <a class="back" @click="() => step = step - 1">
          <mdb-icon icon="chevron-left" />
        </a>
        <mdb-card-title>Créer une conversation</mdb-card-title>
        <mdb-card-text>Est-ce que la question parle d'un moment que vous avez tous vécu? <br />
          Répondre oui va créer la question avec un template de réponse constructive.
        </mdb-card-text>
        <mdb-btn class="brown lighten-1" @click="createConversation(false)">Non</mdb-btn>
        <mdb-btn class="orange darken-1" rounded @click="createConversation(true)">Oui</mdb-btn>
      </mdb-card-body>
    </mdb-card>

  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapGetters, mapState } from "vuex";
import ListUsers from "@/components/ListUsers.vue";
import {
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbAlert,
  mdbIcon
} from "mdbvue";
export default {
  name: "AddConversation",
  components: {
    ListUsers,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbAlert,
    mdbIcon
  },
  computed: {
    ...mapGetters("social", ["getContacts"]),
    ...mapGetters("questions", ["getQuestions"]),
    ...mapState("social", ["usersRef"]),
    results: function() {
      let lowerSearch = this.searchQuery.toLowerCase();
      let alreadySelected = new Set(this.selected);
      return this.getContacts
        .filter(c =>
          this.usersRef[c].displayName.toLowerCase().includes(lowerSearch)
        )
        .filter(c => !alreadySelected.has(c));
    }
  },
  data() {
    return {
      searchQuery: "",
      selected: [],
      valid2: true,
      question: "",
      fromQuestion: false,
      step: 0
    };
  },
  methods: {
    selectContact: function(user) {
      this.selected.push(user);
      this.selected = [...new Set(this.selected)];
    },
    removeContact: function(user) {
      this.selected = this.selected.filter(u => u != user);
    },
    doneSelectingUsers: function() {
      if (this.selected.length == 0) {
        Swal.fire({
          title: "Vous n'avez pas sélectionné de contact",
          text:
            "Vous pouvez être seul à écrire sur une question, est-ce que c'est bien ce que vous désirez?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "Annuler",
          confirmButtonText: "Confirmer"
        }).then(result => {
          if (result.value) {
            this.step++;
            this.loadQuestion();
          }
        });
      } else {
        this.step++;
        this.loadQuestion();
      }
    },
    doneWritingQuestion: function(){
      if (!this.question) {
        this.valid2 = false;
        return;
      }
      this.step++;
    },
    createConversation: async function(withTemplate) {
      let conv = {
        question: this.question,
        others: this.selected,
        withTemplate
      };
      let id = await this.$store.dispatch(
        "conversations/createConversation",
        conv
      );
      console.log(id);
      this.$router.push({
        name: "conversationchat",
        params: {
          conversationId: id
        }
      });
    },
    loadQuestion: async function() {
      let id = this.$route.params.questionID;
      let question = "";
      if (id) {
        this.fromQuestion = await this.$store.dispatch("questions/find", id);
        this.question = this.fromQuestion.question;
      }
    }
  },
  mounted: function() {}
};
</script>

<style scoped>
.back{
  position: absolute;
  top:20px;
  left:20px;
  padding:10px;
}
</style>